module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_07 (14).8a249ce.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_07 (14).mp4
// module id = 789
// module chunks = 1